import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  TooltipProps,
  TooltipPayload,
} from "recharts";
import {
  COLOR_BED_VENT_COVID,
  COLOR_BED_VENT_NON_COVID,
  COLOR_BED_VENT_AVAILABLE,
} from "../../../GlobalColors";

interface ResourceChartProps {
  resource: string;
  data: App.ResourceElement[];
}

export default function ResourceChart(props: ResourceChartProps) {
  const { resource, data } = props;

  function resourceTooltip({
    payload,
    label,
    active,
  }: {
    payload?: ReadonlyArray<TooltipPayload> | undefined;
    label?: string | number | undefined;
    active?: boolean | undefined;
  }) {
    if (!active! || !payload || payload.length !== 3) return null;

    const getTotal = data.find((record) => record.date === label)?.total;

    return (
      <div className="chart-tooltip bg-light p-2">
        <p className="font-weight-bold mb-2">{`Date: ${label}`}</p>
        <p className="mb-1">
          <span style={{ color: COLOR_BED_VENT_COVID }}>{"\u25A0"} </span>
          {`${resource} in Use - COVID: ${payload[0].value} %`}
        </p>
        <p className="mb-1">
          <span style={{ color: COLOR_BED_VENT_NON_COVID }}>{"\u25A0"} </span>
          {`${resource} in Use - Non-COVID: ${payload[1].value} %`}
        </p>
        <p className="mb-2">
          <span style={{ color: COLOR_BED_VENT_AVAILABLE }}>{"\u25A0"} </span>
          {`${resource} Available: ${payload[2].value} %`}
        </p>
        <p className="font-weight-bold mb-0">{`Total Capacity: ${getTotal}`}</p>
      </div>
    );
  }

  return (
    <ResponsiveContainer height={400}>
      <AreaChart data={data}>
        <XAxis dataKey="date" />
        <YAxis
          type="number"
          tickFormatter={(value: number) => `${value} %`}
          interval={0}
          ticks={[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
          domain={[0, 100]}
        />
        <Tooltip
          content={(props: TooltipProps) => resourceTooltip(props)}
          formatter={(value) => `${value} %`}
        />
        <Legend />
        <Area
          name={`COVID ${resource}`}
          dataKey="covid"
          stackId="a"
          fill={COLOR_BED_VENT_COVID}
          stroke={COLOR_BED_VENT_COVID}
          strokeWidth={2}
        />
        <Area
          name={`Non-Covid ${resource}`}
          dataKey="nonCovid"
          stackId="a"
          fill={COLOR_BED_VENT_NON_COVID}
          stroke={COLOR_BED_VENT_NON_COVID}
          strokeWidth={2}
        />
        <Area
          name={`Available ${resource}`}
          dataKey="available"
          stackId="a"
          fill={COLOR_BED_VENT_AVAILABLE}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}
